import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RtlStyleService {
 private linkApp = 'riminn-style';
 
 private linkDefault = 'default-style';
 private linkId = 'rtl-style';
 private linkId2 = 'rtl-style-custom';
 private linkId3 = 'rtl-style-toolbar';

  initStyle(isRtl :boolean){
    let styleLink = '/assets/css/careox.css';
    let link = document.createElement('link');
    link.id = this.linkDefault ;
    link.rel = 'stylesheet';
    if(isRtl){
      link.id = this.linkId ;
      styleLink = '/assets/css/careox-rtl.css';
    }
    
    link.href =styleLink;
     const target = document.getElementById('riminn-style');
    if (target) {
        target.insertAdjacentElement('afterend', link);
    }

    if(isRtl){
      const link2 = document.createElement('link');
      link2.id = this.linkId2 ;
      link2.rel = 'stylesheet';
      link2.href = '/assets/css/careox-custom-rtl.css';
      const target2 = document.getElementById(link.id);
      if (target2) {
          target2.insertAdjacentElement('afterend', link2);
      }
    }

  }
  enable() {
    if (document.getElementById(this.linkId)) return;

    const link = document.createElement('link');
    link.id = this.linkId;
    link.rel = 'stylesheet';
    link.href = '/assets/css/careox-rtl.css';
    
    const target = document.getElementById('riminn-style');
    if (target) {
        target.insertAdjacentElement('afterend', link);
    }

    const link2 = document.createElement('link');
    link2.id = this.linkId2 ;
    link2.rel = 'stylesheet';
    link2.href = '/assets/css/careox-custom-rtl.css';
     const target2 = document.getElementById(link.id);
    if (target2) {
        target2.insertAdjacentElement('afterend', link2);
    }

    
    
    const linkFr = document.getElementById(this.linkDefault);
    if (linkFr) {
      linkFr.remove();
    }

  }

  disable() {

    const linkFr = document.createElement('link');
    linkFr.id = this.linkDefault;
    linkFr.rel = 'stylesheet';
    linkFr.href = '/assets/css/careox.css';
    
    const target = document.getElementById(this.linkId);
    if (target) {
        target.insertAdjacentElement('afterend', linkFr);
    }


    const link = document.getElementById(this.linkId);
    if (link) {
      link.remove();
    }

    const link2 = document.getElementById(this.linkId2);
    if (link2) {
      link2.remove();
    }
  } 
}
